import React, { useState } from 'react';
import { formatInr } from './waStageLabels';
import WaFunnelChart from './WaFunnelChart';

export default function WaConversionPanel({ onLoad }) {
  const [range, setRange] = useState('7d');
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = async (r = range) => {
    setLoading(true);
    try {
      const now = new Date();
      const to = now.toISOString().slice(0, 10);
      let from;
      if (r === 'today') {
        from = to;
      } else if (r === '30d') {
        const d = new Date(now);
        d.setDate(d.getDate() - 30);
        from = d.toISOString().slice(0, 10);
      } else {
        const d = new Date(now);
        d.setDate(d.getDate() - 7);
        from = d.toISOString().slice(0, 10);
      }
      const res = await onLoad({ from, to });
      setData(res);
    } catch {
      setData(null);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    load(range);
  }, [range]);

  const d = data || {};
  return (
    <div className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm mb-6">
      <div className="flex flex-wrap items-center justify-between gap-2 mb-4">
        <h2 className="font-semibold text-[#1B375B]">Conversion analytics</h2>
        <div className="flex gap-1">
          {['today', '7d', '30d'].map((r) => (
            <button
              key={r}
              type="button"
              onClick={() => setRange(r)}
              className={`px-3 py-1 text-xs rounded-lg ${
                range === r ? 'bg-[#1B375B] text-white' : 'bg-gray-100 text-gray-600'
              }`}
            >
              {r === 'today' ? 'Today' : r}
            </button>
          ))}
        </div>
      </div>
      {loading ? (
        <p className="text-sm text-gray-500">Loading…</p>
      ) : (
        <>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4">
            <div className="border rounded-lg p-2">
              <p className="text-xs text-gray-500">Sessions</p>
              <p className="font-bold">{d.sessions_started ?? 0}</p>
            </div>
            <div className="border rounded-lg p-2">
              <p className="text-xs text-gray-500">Bookings</p>
              <p className="font-bold">{d.bookings_completed ?? 0}</p>
            </div>
            <div className="border rounded-lg p-2">
              <p className="text-xs text-gray-500">Conversion</p>
              <p className="font-bold">{d.conversion_rate_pct ?? 0}%</p>
            </div>
            <div className="border rounded-lg p-2">
              <p className="text-xs text-gray-500">Revenue</p>
              <p className="font-bold">{formatInr(d.revenue_inr)}</p>
            </div>
          </div>
          <p className="text-xs text-gray-500 mb-2">
            WhatsApp cohort in bookings collection: {d.whatsapp_cohort_bookings ?? 0}
          </p>
          <WaFunnelChart funnel={d.reached_stage} title="Stage reach (date range)" />
        </>
      )}
    </div>
  );
}
